import { CommentRootUuid, parseComment } from '../../models/Comment'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type CreateCommentArguments = {
  title?: string
  text: string
  parentUuid?: string
} & CommentRootUuid

export default function useCreateComment() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: CreateCommentArguments) => {
      const payload = {
        parent_uuid: data.parentUuid,
        title: data.title,
        text: data.text,
      }

      const res =
        'groupUuid' in data
          ? await api.post(`group/${encodeURIComponent(data.groupUuid)}/comment`, payload)
          : await api.post(`course/${encodeURIComponent(data.learningItemUuid)}/comment`, payload)

      await invalidate.comments()

      return parseComment(res)
    },
  })
}
